import { render, staticRenderFns } from "./PanelInfo.vue?vue&type=template&id=b1ed06da"
import script from "./PanelInfo.vue?vue&type=script&lang=js"
export * from "./PanelInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports